import type { Step } from "react-joyride";

export const otApprovalListTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າອະນຸມັດ OT. ເບິ່ງ ແລະ ອະນຸມັດ ຫຼື ປະຕິເສດຄຳຂໍ OT ຈາກພະນັກງານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="ot-approval-toolbar"]',
    content:
      "ສົ່ງອອກ CSV ຫຼື ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-approval-summary"]',
    content: "ສະຫຼຸບຈຳນວນຄຳຂໍລໍຖ້າອະນຸມັດໃນເດືອນທີ່ເລືອກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-approval-filter"]',
    content: "ກັ່ນຕອງຕາມປີ, ເດືອນ, ສະຖານະ ແລະ ຄົ້ນຫາພະນັກງານ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="ot-approval-table"]',
    content:
      "ຕາຕະລາງຄຳຂໍ OT. ກົດເບິ່ງ, ອະນຸມັດ ຫຼື ປະຕິເສດຕາມສະຖານະ.",
    placement: "top",
  },
];
